var Task = /** @class */ (function () {
    function Task(task) {
        if (task) {
            Object.assign(this, task);
        }
    }
    Object.defineProperty(Task.prototype, "information", {
        set: function (taskInformation) {
            this.name = taskInformation.name;
            this.description = taskInformation.description;
            this.driverDescription = taskInformation.driverDescription;
            this.service = taskInformation.service;
            this.order = taskInformation.order;
            this.customer = taskInformation.customer;
            this.measurementUnits = taskInformation.measurementUnits;
            this.hourlyRate = taskInformation.hourlyRate;
            this.diameter = taskInformation.diameter;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Task.prototype, "billingDetails", {
        set: function (billing) {
            this.measurementUnits = billing.measurementUnits;
            this.hourlyRate = billing.hourlyRate;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Task.prototype, "schedule", {
        set: function (schedule) {
            this.employee = schedule.employee;
            this.updateEmployeeOnWorklogItems = schedule.updateEmployeeOnWorklogItems;
            this.machine = schedule.machine;
            this.attachments = schedule.attachments;
            this.date = schedule.date;
            this.time = schedule.time;
        },
        enumerable: true,
        configurable: true
    });
    return Task;
}());
export { Task };
